/*
 Created by CHT 2019/8/28 17:37
 */

/**
 * 重定向 指针
 * @param cur
 * @param oth
 * @param protoCome
 * @return {*}
 */
export function doExtend(cur, oth, protoCome) {
	Object.assign(cur, oth)
	protoCome.__proto__ = oth.__proto__
	return protoCome.__proto__
}

/**
 * 构建 以 0 1 存储true false 切换方法
 * @param cls
 * @param field
 * @param proxy
 * @return {boolean}
 */
export function numberBool(cls, field, proxy) {
	Object.defineProperty(cls.prototype, proxy, {
		get() {
			return Boolean(this[field])
		},
		set(bool) {
			this[field] = Number(bool)
		}
	})
}

/**
 * 金额转大写
 * @param n
 * @return {string}
 */
export function convertCurrency(n) {
	let fraction = ['角', '分']
	let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
	let unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
	let head = n < 0 ? '欠' : ''
	n = Math.abs(n)

	let s = ''

	for (let i = 0; i < fraction.length; i++) {
		s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
	}
	s = s || '整'
	n = Math.floor(n)

	for (let i = 0; i < unit[0].length && n > 0; i++) {
		let p = ''
		for (let j = 0; j < unit[1].length && n > 0; j++) {
			p = digit[n % 10] + unit[1][j] + p
			n = Math.floor(n / 10)
		}
		s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
	}
	return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}

/**
 * 时间戳格式化
 * @param d
 * @return {(function(*=): *)|(function(*): string)}
 */
export function formatDate(d) {
	d = parseInt(d)
	if (d > 0) {
		let date = new Date(d)
		return fmt => { //author: meizz
			let o = {
				'M+': date.getMonth() + 1, //月份
				'd+': date.getDate(), //日
				'H+': date.getHours(), //小时
				'm+': date.getMinutes(), //分
				's+': date.getSeconds(), //秒
				'q+': Math.floor((date.getMonth() + 3) / 3), //季度
				'S': date.getMilliseconds() //毫秒
			}
			if (/(y+)/.test(fmt)) {
				fmt =
					fmt.replace(RegExp.$1, (date.getFullYear() + ``).substr(4 - RegExp.$1.length))
			}
			for (let k in o) {
				if (new RegExp(`(${k})`).test(fmt)) {
					fmt =
						fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00` + o[k]).substr(
							(`` + o[k]).length)))
				}
			}
			return fmt
		}
	} else {
		return (d) => {
			return ``
		}
	}
}

/**
 * 克隆
 * @param o
 * @return {any}
 */
export function clone(o) {
	return JSON.parse(JSON.stringify(o))
}
